import React, { useState } from "react";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import { Button } from "react-bootstrap";

const ChargeRegProp = () => {
  const [file, setFile] = useState(null);
  const [typeChrage, setTypeChrage] = useState("");
  const isSubmitDisabled = !file || !typeChrage;

  const handleTypeChrageChange = (e) => {
    setTypeChrage(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }

    try {
      const response = await CreacionTitulosService.postPropsRegisters(file, typeChrage);
      console.log(response);
      alert("Archivo enviado con éxito");
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      alert("Error al enviar el archivo");
    }
  };

  return (
    <div>
      <div className="container mt-5">
        <div className="card p-4 shadow">
          <h3 className="text-center mb-4">Carga Registro de la Propiedad en DB</h3>
          <div className="mb-3">
            <label className="form-label">Selecciona una categoría:</label>
            <select
              className="form-select"
              value={typeChrage}
              onChange={handleTypeChrageChange}
            >
              <option value="">-- Selecciona una opción --</option>
              <option value="completa">Completa</option>
              <option value="parcial">Parcial</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Selecciona un archivo:</label>
            <input
              className="form-control"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
            />
          </div>
          <div className="text-center">
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitDisabled}
            >
            Enviar archivo
            </Button>
          </div>
        </div>
      </div>
      

    </div>
  );
};

export default ChargeRegProp;